// ** React Imports
import { useEffect, useState } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Table from '@mui/material/Table'
import Button from '@mui/material/Button'
import Avatar from '@mui/material/Avatar'
import Dialog from '@mui/material/Dialog'
import Tooltip from '@mui/material/Tooltip'
import Checkbox from '@mui/material/Checkbox'
import TableRow from '@mui/material/TableRow'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import DialogTitle from '@mui/material/DialogTitle'
import AvatarGroup from '@mui/material/AvatarGroup'
import CardContent from '@mui/material/CardContent'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import FormHelperText from '@mui/material/FormHelperText'
import TableContainer from '@mui/material/TableContainer'
import FormControlLabel from '@mui/material/FormControlLabel'
import EditIcon from '@mui/icons-material/Edit';
import GroupIcon from '@mui/icons-material/Group';
import LockOpenIcon from '@mui/icons-material/LockOpen';
// ** Third Party Imports
import { useForm, Controller } from 'react-hook-form'

// ** Icons Imports
import DeleteIcon from '@mui/icons-material/Delete';
import InformationOutline from 'mdi-material-ui/InformationOutline'
import { RoleOverview, RolePermission } from 'src/types/common'
import { client } from '../../utils/axios-client'
import { rolePermissionsEndpoint, rolesOverviewEndpoint, saveRoleEndpoint } from '../../configs/endpoints'
import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid';
import RoleStore from '../../stores/RoleStore'
import RenderIf, { ClaimType, ClaimValue } from '../common/RenderIf'
import EditRoleDrawer from './EditRoleDrawer'
import { useTheme } from '@mui/material'
import CreateRoleDialog from './CreateRoleDialog'
import AIWizard from '../AI/components/AIWizard'

type Props = {
    onRoleSelected: (roleId: string) => void
}

const RolesCards = ({ onRoleSelected }: Props) => {
    // ** States
    const [open, setOpen] = useState<boolean>(false)
    const [dialogTitle, setDialogTitle] = useState<'Add' | 'Edit'>('Add')
    const roles = RoleStore.useState(s => s.roles)
    const [rolePermissions, setRolePermissions] = useState({} as RolePermission)
    const [nameError, setNameError] = useState(false);
    const theme = useTheme();
    const [selectedRoleId, setSelectedRoleId] = useState('');
    const [createRoleOpen, setCreateRoleOpen] = useState(false);

    useEffect(() => {
        loadRoles();
    }, [])



    const loadRoles = async () => {
        const response = await client.get(rolesOverviewEndpoint);

        RoleStore.update(s => {
            s.roles = response.data;
        })

        //    if (response.data.length > 0) {
        //        onRoleSelected(response.data[0].id);
        //        setOpen(true);
        //    }
    }



    const handleClickOpen = () => setOpen(true)

    const handleClose = async () => {
        setOpen(false)
        await loadRoles()
        //setRolePermissions({} as RolePermission)
        //setValue('name', '')
    }


    const deleteRole = async (roleId: string) => {
        const result = confirm("Are you sure you want to delete the role?");

        if (result) {
            try {
                const result = await client.delete(`/api/admin/roles/${roleId}/delete`);
                await loadRoles()
            } catch (err) {
                alert(err.error);
            }                       
        }
    }

    const renderCards = () =>
        roles.map((item, index: number) => (
            <Grid item xs={12} sm={6} lg={4} key={index}>
                <Card variant={item.id == selectedRoleId ? 'outlined' : undefined} >
                    <CardContent>
                        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant='body2'>Total {item.numberOfUsers} users </Typography>
                            <AvatarGroup
                                max={4}
                                sx={{
                                    '& .MuiAvatarGroup-avatar': { fontSize: '.875rem' },
                                    '& .MuiAvatar-root, & .MuiAvatarGroup-avatar': { width: 32, height: 32 }
                                }}
                            >
                                {item.avatars.map((img, index: number) => (
                                    <Avatar key={index} alt={item.name} src={img} />
                                ))}
                            </AvatarGroup>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant='h6'>{item.name}</Typography>
                            {/*{item.name.toUpperCase() !== "ADMIN" && item.name.toUpperCase() !== "PENDING (NO ACCESS)" &&*/}
                            {/*    <IconButton simze="small" title="Rename Group"><EditIcon fontSize='small' /></IconButton>*/}
                            {/*}*/}
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <RenderIf claimType={ClaimType.Roles} claimValue={ClaimValue.Delete}>
                                {item.name.toUpperCase() !== "ADMIN" && item.name.toUpperCase() !== "PENDING (NO ACCESS)" && <IconButton title="Edit Permissions" size='small' sx={{ color: 'text.primary' }} onClick={() => {
                                    setSelectedRoleId(item.id);
                                    handleClickOpen()
                                    setDialogTitle('Edit')
                                }}>
                                    <LockOpenIcon fontSize='small' />
                                </IconButton>}
                            </RenderIf>

                            <RenderIf claimType={ClaimType.Roles} claimValue={ClaimValue.Delete}>
                                <IconButton title="Show Users" size='small' sx={{ color: 'text.primary' }} onClick={() => onRoleSelected(item.id)} >
                                    <GroupIcon fontSize='small' />
                                </IconButton>
                            </RenderIf>

                            <RenderIf claimType={ClaimType.Roles} claimValue={ClaimValue.Delete}>
                                {item.name.toUpperCase() !== "ADMIN" && item.name.toUpperCase() !== "PENDING (NO ACCESS)" && <IconButton title="Delete Role" size='small' sx={{ color: 'text.primary' }} onClick={() => deleteRole(item.id)}>
                                    <DeleteIcon fontSize='small' />
                                </IconButton>}
                            </RenderIf>

                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        ))

    return (
        <Grid container spacing={6} className='match-height'>
            <Grid item xs={12} sm={6} lg={4}>
                <Card>
                    <Grid container sx={{ height: '100%' }}>
                        <Grid item xs={5}>
                            <Box sx={{ height: '100%', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                                <img width={65} height={130} alt='add-role' src='/images/cards/pose_m1.png' />
                            </Box>
                        </Grid>
                        <Grid item xs={7}>
                            <CardContent>
                                <RenderIf claimType={ClaimType.Roles} claimValue={ClaimValue.Add}>
                                    <Box sx={{ textAlign: 'right' }}>
                                        <Button
                                            size="small"
                                            variant='contained'
                                            sx={{ mb: 3, whiteSpace: 'nowrap' }}
                                            onClick={() => {
                                                setSelectedRoleId(uuidv4())
                                                setCreateRoleOpen(true);

                                            }}
                                        >
                                            Add Role
                                        </Button>
                                        <Typography>Add role, if it doesn't exist.</Typography>
                                    </Box>
                                </RenderIf>

                            </CardContent>
                        </Grid>
                    </Grid>
                </Card>
            </Grid>
            {renderCards()}

            <EditRoleDrawer open={open} onClose={handleClose} selectedRoleId={selectedRoleId} key={selectedRoleId} />
            <CreateRoleDialog open={createRoleOpen} onCancel={() => setCreateRoleOpen(false)} roleId={selectedRoleId} key={selectedRoleId} onSaved={() => {
                handleClickOpen()
                setCreateRoleOpen(false);
                setDialogTitle('Edit')
            }} />
            {/*<Dialog fullWidth maxWidth='md' scroll='body' onClose={handleClose} open={open}>*/}

            {/*</Dialog>*/}
        </Grid>
    )
}

export default RolesCards

